// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import SingleArrow from '../_raw/ui/icon_single_arrow.svg';
import withIconProps from '../withIconProps';

export default withIconProps(SingleArrow);
